/**
 * Copyright (c) Qwoach LLC 2023. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 1.05.23
 *
 */

let CommonObject = {}

export default CommonObject
